import React from "react";

const PostShimmer = () => {
  return (
    <div className="bg-white rounded-2xl border shadow-md p-5">
      <div className="flex items-start gap-3">
        <div className="min-w-12 min-h-12 shimmer rounded-xl"></div>
        <div className="flex flex-col gap-3 w-full">
          <div className="flex mt-1 gap-3">
            <div className="shimmer rounded-xl h-[13px] w-[140px]"></div>
            <div className="shimmer rounded-xl h-[13px] w-[70px]"></div>
          </div>
          <div className="grid shimmer-title--secondary grid-gap-10">
            <div className="shimmer shimmer-title-line"></div>
            <div className="shimmer shimmer-title-line"></div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center mt-3">
        <div className="flex gap-3">
          <div className="shimmer rounded-xl h-[13px] w-[70px]"></div>
          <div className="shimmer rounded-xl h-[13px] w-[70px]"></div>
        </div>
        <div className="flex gap-3">
          <div className="shimmer rounded-xl h-[13px] w-[35px]"></div>
          <div className="shimmer rounded-xl h-[13px] w-[35px]"></div>
          <div className="shimmer rounded-xl h-[13px] w-[35px]"></div>
        </div>
      </div>
    </div>
  );
};

export default PostShimmer;
